import React, { Fragment } from "react";
import PropTypes from "prop-types";
import s from "./style.module.css";
import { Button, Modal } from "react-bootstrap";
// import localization from "assets/localization/localization";
// import Loader from "components/sales/Loader/loader";

const ModalPop = ({
                      title = "title",
                      children,
                      show,
                      footer = false,
                      handleModalHide,
                      keyboard = false,
                      backdrop = false,
                      footerCloseBtn = false,
                      handleModalSubmit,
                      footerSubmitTxt = null,
                      isLoading = false,
                      url=''
                  }) => {
    return (
        <Fragment>
            <Modal
                animation={false}
                show={show}
                onHide={handleModalHide}
                keyboard={keyboard ? false : true}
                backdrop={backdrop ? "static" : true}
                dialogClassName={s.root}
                scrollable
            >

                {url !== '' ?
                    <Modal.Header >
                        <Modal.Title>{title}</Modal.Title>
                        <a href={url} style={{"color":"red"}}>X</a>
                    </Modal.Header>
                    :
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                }
                <Modal.Body>{children}</Modal.Body>
                {footer ? (
                    <Modal.Footer>
                        {footerCloseBtn ? (
                            <Button onClick={handleModalHide}>close</Button>
                        ) : null}
                        <Button onClick={handleModalSubmit}>
                            {footerSubmitTxt || 'saveChanges'}
                        </Button>
                    </Modal.Footer>
                ) : null}
            </Modal>
            {/*<Loader isLoading={isLoading} />*/}
        </Fragment>

    );
};

ModalPop.propTypes = {
    show: PropTypes.bool,
};

export default ModalPop;
